import * as stripe from './configStripe';
import * as listing from './configListing';
import * as search from './configSearch';
import * as maps from './configMaps';
import * as branding from './configBranding';
import * as analytics from './configAnalytics';
import * as user from './configUser';

// NOTE: only expose configuration that should be visible in the
// client side, don't add any server secrets to this file.
const defaultConfig = {
  marketplaceRootURL: process.env.REACT_APP_MARKETPLACE_ROOT_URL,

  currency: 'USD',
  listingMinimumPriceSubUnits: 500,

  marketplaceName: process.env.REACT_APP_MARKETPLACE_NAME || 'Bean Pigeon',

  stripe: { ...stripe },
  listing: { ...listing },
  user: { ...user },

  search: { ...search },
  maps: { ...maps },
  branding: { ...branding },

  // IMPORTANT: define layout explicitly so mergeLayouts never sees undefined
  layout: {
    searchPage: { variantType: 'map' },
    listingPage: { variantType: 'carousel' },
    listingImage: {
      variantType: 'cropImage',
      aspectRatio: '4/3',
      variantPrefix: 'listing-card',
    },
  },

  analytics: { ...analytics },

  facebookAppId: process.env.REACT_APP_FACEBOOK_APP_ID,

  localization: {
    locale: 'en-US',
    firstDayOfWeek: 1,
  },

  // MVP / pure discovery: do not fetch hosted assets
  appCdnAssets: {},

  // Access control fallback (avoid reserved key "private")
  accessControl: {
    marketplace: {
      isPrivate: false,
    },
  },

  categoryConfiguration: {
    key: 'categoryLevel',
    categories: [],
  },

  siteFacebookPage: null,
  siteInstagramPage: null,
  siteTwitterHandle: null,

  googleSearchConsole: {
    googleSiteVerification: null,
  },

  address: {
    addressCountry: null,
    addressRegion: null,
    postalCode: null,
    streetAddress: null,
  },
};

export default defaultConfig;